

<div class="w-full py-3 px-4">
  <div class="flex items-center justify-between mb-0">
    <!-- <div class="flex items-center justify-start gap-1 lg:gap-2">
      <svg
        class="size-6 cursor-pointer"
        [routerLink]="['/admin-panel/adminstaff-list/adminstaff-list']"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_848_1764"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <rect width="24" height="24" fill="#C19725" />
        </mask>
        <g mask="url(#mask0_848_1764)">
          <path
            d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z"
            fill="#C19725"
          />
        </g>
      </svg>
      <img
        class="size-6 sm:size-8 lg:size-10"
        src="/assets/images/stock/ready-product.png"
        alt="Tagging"
        *ngIf="titleTag"
      />
      <span
        class="font-semibold text-sm sm:text-base lg:text-xl text-444"
        *ngIf="titleTag"
        >Tagged Product List</span
      >
    </div> -->
    <!-- <div></div> -->
  </div>
 <!-- <div class="p-3 mb-3 bg-white border-l-4 border-green-600 rounded-md bg-green-50/40">
  <div class="relative inline-block px-3 py-2 text-lg font-semibold text-green-700 rounded-md overflow-hidden shine-wrapper">
    Issue stock to: {{ staffName }} (ID: {{ staffId }})
    <span class="shine-effect absolute inset-0"></span>
  </div>
</div> -->

  <!-- <div class="flex flex-wrap lg:flex-nowrap justify-between items-center gap-2">
    <div
      class="flex items-center justify-center md:justify-start gap-1 sm:gap-2"
    >
      <div class="relative flex items-center gap-1 sm:gap-2">
        <label
          for="rowFilter"
          class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap"
        >
          Rows :
        </label>
        <select
          id="rowFilter"
          [(ngModel)]="itemsPerPage"
          (change)="filterTable()"
          class="border border-dcdcdc rounded-[5px] p-1 text-xs sm:text-sm appearance-none !bg-none pr-6 focus:outline-none focus:ring-0 focus:border-c19725"
        >
          <option
            *ngFor="let count of [5, 10, 20, 30, 40, 50, 100]"
            [value]="count"
          >
            {{ count }}
          </option>
        </select>
        <div
          class="absolute inset-y-0 right-1.5 flex items-center pointer-events-none"
        >
          <svg
            width="10"
            height="5"
            viewBox="0 0 14 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.00004 7.00016L0.333374 0.333496H13.6667L7.00004 7.00016Z"
              fill="#C19725"
            />
          </svg>
        </div>
      </div>

      <div class="flex items-center gap-1 sm:gap-2">
        <label
          for="globalSearch"
          class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap"
        >
          Search :
        </label>
        <input
          id="globalSearch"
          type="text"
          [(ngModel)]="globalSearchText"
          (ngModelChange)="filterTable()"
          placeholder="Search all columns..."
          class="border border-dcdcdc rounded-[5px] px-3 py-1 text-xs sm:text-sm w-32 lg:w-64 focus:outline-none focus:ring-0 focus:border-c19725"
          autocomplete="off"
        />
      </div>
    </div>

    <div
      class="flex items-center flex-wrap lg:flex-nowrap justify-center md:justify-end gap-2"
    >
      <button
        class="text-[#F20707] border-1 border-[#F20707] bg-[#fff6f3] font-medium text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadPDF()"
      >
        Download PDF
      </button>
      <button
        class="text-[#029921] border-1 border-[#029921] bg-[#e6ffe6] font-medium text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadExcel()"
      >
        Download Excel
      </button>
      <button
        class="text-[#0720EC] border-1 border-[#0720EC] bg-[#E8E6FF] font-medium text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadJSONAll()"
      >
        Download All JSON
      </button>
      <button
        class="text-[#00ad94] border-1 border-[#00ad94] bg-[#e5fffb] font-medium text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadCSV()"
      >
        Download CSV
      </button>

      <div class="relative inline-block text-left">
        <button
          (click)="toggleDropdown()"
          class="text-[#B92185] border-1 border-[#B92185] bg-[#FFE1F5] font-medium text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        >
          Column Visibility
        </button>

        <div
          *ngIf="showDropdown"
          class="absolute z-50 mt-2 p-4 bg-white border rounded shadow -left-24 w-64"
        >
          <p class="font-semibold mb-2">Select Columns to Show:</p>

          <label
            *ngFor="let field of selectedFields"
            class="block text-sm mb-1"
          >
            <input
              type="checkbox"
              [(ngModel)]="field.selected"
              (change)="onFieldToggle(field)"
              autocomplete="off"
            />
            {{ field.label }}
          </label>

          <div class="mt-3 flex flex-col gap-2">
            <button
              (click)="selectAllFields()"
              class="text-sm text-blue-600 hover:underline text-left"
            >
              Select All
            </button>
            <button
              (click)="deselectAllFields()"
              class="text-sm text-red-800 hover:underline text-left"
            >
              Deselect All
            </button>
            <button
              (click)="restoreColumnSelection()"
              class="text-sm text-gray-600 hover:underline text-left"
            >
              Restore Columns
            </button>

            <button
              (click)="applyColumnSelection()"
              class="mt-2 bg-blue-600 text-white text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-blue-700 transition"
            >
              Apply
            </button>
          </div>
        </div>
      </div>
      <button
        (click)="printTable()"
        class="text-[#5606b6] border-1 border-[#5606b6] bg-[#ecddff] font-medium text-sm px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
      >
        Print
      </button>
    </div>
  </div> -->
  <div class="flex items-center justify-between gap-4 mt-4">
    <!-- LEFT : Scan input -->
    <form (ngSubmit)="onScanSubmit()">
      <input
        type="text"
        [(ngModel)]="scannedValue"
        name="barcode"
        placeholder="Scan Barcode..."
        autofocus
        class="w-full max-w-[900px] px-3 py-2 border border-gray-300 rounded
               focus:outline-none focus:ring-1 focus:ring-blue-500"
      />
    </form>

    <!-- RIGHT : Buttons -->
    <div class="flex gap-4">
      <button
        class="px-4 py-2 rounded bg-blue-600 text-white"
        (click)="loadPendingList()"
      >
        Pending Tags
      </button>

      <button
        class="px-4 py-2 rounded bg-green-700 text-white"
        (click)="loadIssuedList()"
      >
        Issued List
      </button>
    </div>
  </div>

  <div class="overflow-x-auto whitespace-nowrap hide-scrollbar mt-10">
    <table
      class="w-full table border border-b-0 border-[#D9D9D9] border-separate border-spacing-0 bg-white overflow-hidden"
    >
      <thead class="bg-[#F2F2F2] text-444 text-xs sm:text-sm lg:text-base">
        <tr>
          <th
            class="p-2 font-medium text-center border-r border-444 last:border-r-0"
          >
            No.
          </th>
          <th
            *ngFor="let field of selectedFields"
            [hidden]="!field.selected"
            class="p-2 font-medium text-left border-r border-444 last:border-r-0"
          >
            <div class="flex flex-col gap-1 w-32">
              <input
                type="text"
                [(ngModel)]="searchValues[field.key]"
                (click)="$event.stopPropagation()"
                (ngModelChange)="filterTable()"
                [attr.placeholder]="'Search ' + field.label"
                class="border border-dcdcdc p-1 rounded-[5px] text-xs w-full"
                autocomplete="off"
              />

              <div
                class="text-xs font-medium text-gray-700 flex items-center gap-1 cursor-pointer select-none"
                (click)="sortBy(field.key)"
              >
                {{ field.label }}
                <svg
                  *ngIf="sortKey === field.key"
                  class="w-3 h-3"
                  viewBox="0 0 24 24"
                >
                  <path
                    *ngIf="sortDirection === 'asc'"
                    d="M12 8l6 6H6z"
                    fill="currentColor"
                  />
                  <path
                    *ngIf="sortDirection === 'desc'"
                    d="M12 16l-6-6h12z"
                    fill="currentColor"
                  />
                </svg>
              </div>
            </div>
          </th>
          <th
            *ngIf="!isIssuedList"
            class="p-2 font-medium text-center border-r border-444"
          >
            Stock Issue
          </th>

          <th
            class="p-2 font-medium text-center border-r border-444 last:border-r-0"
          >
            Action
          </th>
        </tr>
      </thead>
      <tbody class="text-xs sm:text-sm">
        <tr
          class="odd:bg-white even:bg-[#F2F2F2] text-[#5A5959]"
          *ngFor="let tag of paginatedTaggingsList; let i = index"
        >
          <td class="p-3 text-center border-r border-b border-[#D9D9D9]">
            {{ (currentPage - 1) * itemsPerPage + i + 1 }}
          </td>

          <ng-container *ngFor="let field of selectedFields">
            <td
              *ngIf="field.selected"
              class="p-3 border-r border-b border-[#D9D9D9]"
            >
              <ng-container *ngIf="field.key === 'tag_image'; else otherField">
                <img
                  *ngIf="tag.tag_image"
                  [src]="tag.tag_image"
                  alt="Tag Image"
                  class="w-10 h-10 object-cover rounded"
                />
              </ng-container>
              <ng-template #otherField>
                {{ getDisplayValue(tag[field.key]) || "-" }}
              </ng-template>
            </td>
          </ng-container>

          <td 
            *ngIf="!isIssuedList"
            class="p-3 text-center border-r border-b border-[#D9D9D9]">
            
             <button 
              (click)="issueStock(tag.std_id, tag)"
              class="gold-button flex items-center gap-1 px-3 py-1.5 rounded-full text-xs sm:text-sm font-semibold">

              <!-- svg icon -->
              Issue Stock
              <span class="shine-effect"></span>
            </button>

          </td>

          <td class="p-3 text-center border-r border-b border-[#D9D9D9]">
            <div class="flex items-center justify-center gap-1 sm:gap-2">
            

              <button class="cursor-pointer p-1" (click)="viewTag(tag)">
                <svg
                  class="w-4 h-4 sm:w-5 sm:h-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.5 12C3.6 7.5 7.5 4.5 12 4.5C16.5 4.5 20.4 7.5 22.5 12C20.4 16.5 16.5 19.5 12 19.5C7.5 19.5 3.6 16.5 1.5 12Z"
                    stroke="#C19725"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke="#C19725"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>

              <button
                class="cursor-pointer p-1"
                (click)="deleteTag(tag.std_id)"
              >
                <svg
                  class="w-4 h-4 sm:w-5 sm:h-5"
                  viewBox="0 0 24 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 12.5V17.5"
                    stroke="#BB0000"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14 12.5V17.5"
                    stroke="#BB0000"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M4 7.5H20"
                    stroke="#BB0000"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6 10.5V18.5C6 20.1569 7.34315 21.5 9 21.5H15C16.6569 21.5 18 20.1569 18 18.5V10.5"
                    stroke="#BB0000"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 5.5C9 4.39543 9.89543 3.5 11 3.5H13C14.1046 3.5 15 4.39543 15 5.5V7.5H9V5.5Z"
                    stroke="#BB0000"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </td>
        </tr>
        <tr *ngIf="paginatedTaggingsList.length === 0">
          <td
            [attr.colspan]="selectedFieldss.length + 2"
            class="p-3 text-center border-b border-[#D9D9D9] text-[#5A5959]"
          >
            No tags found.
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div
    class="flex items-center justify-end border-t border-gray-200 bg-white py-3"
  >
    <div class="flex sm:flex-1 sm:items-center sm:justify-end">
      <div>
        <nav
          class="isolate inline-flex gap-2 -space-x-px rounded-md shadow-xs"
          aria-label="Pagination"
        >
          <button
            (click)="goToPreviousPage()"
            [disabled]="currentPage === 1"
            class="relative inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0"
          >
            <span class="sr-only">Previous</span>
            <svg
              class="size-6"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
              data-slot="icon"
            >
              <path
                fill-rule="evenodd"
                d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
          <ng-container *ngFor="let page of pageNumbers">
            <ng-container *ngIf="page !== -1; else ellipsis">
              <button
                (click)="goToPage(+page)"
                [class.bg-c19725]="currentPage === page"
                [class.text-white]="currentPage === page"
                class="relative z-10 inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-sm font-normal text-c19725 ring-1 ring-c19725 ring-inset focus:z-20 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-c19725"
              >
                {{ page }}
              </button>
            </ng-container>
            <ng-template #ellipsis>
              <span
                class="relative inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-sm font-normal text-gray-700 focus:outline-offset-0"
                >...</span
              >
            </ng-template>
          </ng-container>

          <button
            (click)="goToNextPage()"
            [disabled]="currentPage === totalPages"
            class="relative inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0"
          >
            <span class="sr-only">Next</span>
            <svg
              class="size-6"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
              data-slot="icon"
            >
              <path
                fill-rule="evenodd"
                d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </nav>
      </div>
    </div>
  </div>
</div>
